module.exports = __webpack_public_path__ + "img/water_norms_img.87e58dcd.png";